import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { Client, MeterMakeDataIn } from '../../../../../api/api-reference';

@Component({
  selector: 'app-meter-make-setup',
  standalone: true,
  imports: [FormsModule, TranslateModule, AngularSvgIconModule, CommonModule],
  templateUrl: './meter-make-setup.component.html',
  styleUrl: './meter-make-setup.component.scss',
})
export class MeterMakeSetupComponent implements OnInit {
  @Input() selectedMeterMake: string | null = null;
  @Output() close = new EventEmitter<boolean>();
  data: MeterMakeDataIn = new MeterMakeDataIn();

  @ViewChild('crudform') crudform!: NgForm;
  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}
  ngOnInit(): void {
    this.getMeterMake();
  }

  getMeterMake() {
    if (this.selectedMeterMake) {
      this.client.getMeterMake(this.selectedMeterMake).subscribe({
        next: (response) => {
          this.data.id = response.id;
          this.data.name = response.name ?? '';
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    }
  }

  toggleModal(reaload?: boolean) {
    this.close.emit(reaload);
  }

  onSubmit() {
    this.client.saveMeterMake(this.data).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.toggleModal(true);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
